module.exports = __webpack_public_path__ + "img/rememberHover.2211a5b7.svg";